import { ICompatibilityReport } from '../api/models/compatibilityReport/compatibilityReport.types';
import { ECompatibilityReportType } from '../api/models/member/member.types';

export enum ECompatibilityReportActionType {
  GET = 'COMPATIBILITY_REPORT/GET',
  GET_SUCCESS = 'COMPATIBILITY_REPORT/GET_SUCCESS',
}

export const compatibilityReportActions = {
  getCompatibilityReport: (payload: ICompatibilityReportPayload) => ({
    type: ECompatibilityReportActionType.GET,
    payload,
  }),
  getCompatibilityReportSuccess: (payload: ICompatibilityReportPayload) => ({
    type: ECompatibilityReportActionType.GET_SUCCESS,
    payload,
  }),
};

export interface ICompatibilityReportPayload {
  accountId: string;
  reportType: ECompatibilityReportType;
  compatibilityReport?: ICompatibilityReport;
}

export interface ICompatibilityReportAction {
  type: ECompatibilityReportActionType;
  payload: ICompatibilityReportPayload;
}
